import { LightboxSource, LightboxSourceType } from '../types';

const getClearSrc = (src: string) => src.split('?')[0];

const isImage = (src: string): boolean => /\.(jpg|jpeg|png|webp|avif|gif)$/.test(getClearSrc(src));

const isVideo = (src: string): boolean => /\.(mp4|mov|avi|mkv|webm)$/.test(getClearSrc(src));

const isAudio = (src: string): boolean => /\.(wav|mp3)$/.test(getClearSrc(src));
const isPdf = (src: string): boolean => /\.(pdf)$/.test(getClearSrc(src));

export const getSourceType = (source: LightboxSource): LightboxSourceType | null => {
    const { src, type } = source;
    if (type) {
        return type;
    }
    if (isImage(src)) {
        return 'image';
    }
    if (isVideo(src)) {
        return 'video';
    }
    if (isAudio(src)) {
        return 'audio';
    }
    if (isPdf(src)) {
        return 'pdf';
    }
    return 'unknown';
};

export const getImageDefaultAlt = (selectedSourceIndex: number) => `Lightbox image ${selectedSourceIndex + 1}`;

export const isSourceLoadable = (source: LightboxSource) => {
    const sourceType = getSourceType(source);

    if (sourceType === 'unknown') {
        return false;
    }

    return true;
};
